<template>
  <div class="edit-value">
    <div class="reading-mode">
      <slot name="read-mode" v-bind="{ value: scopedValue }">
        <span class="text">{{scopedValue}}</span>
      </slot>
      <slot name="switch-mode" v-if="editMode" >
        <button class="btn btn-icon btn-icon-xsmall btn-rounded" @click.prevent="editCurrent">
          <svg class="o-icon"><use xlink:href="#edit"></use></svg>
        </button>
      </slot>
    </div>
    <div class="edit-mode" v-if="editMode && switchToEditMode">
      <slot name="edit-mode" v-bind="{ vModel: inEditingValue, inputName: name, errors }">
        <b-form-group>
          <base-input
            :name="name"
            v-model.trim="inEditingValue"
            type="text"
            :classInput="classInput"
            v-validate="inputValidation"
            :validations="[
              {
                condition: errors.has(name),
                text: errors.first(name)
              }
            ]"
          >
          </base-input>
        </b-form-group>
      </slot>
      <slot name="edit-mode-submit">
        <div class="wrapp-submit">
          <button class="btn btn-primary btn-primary-small btn-primary-with-icon btn-rounded btn-success" @click.prevent="submitValue" :disabled="errors.has(name)">
            <span class="text">{{ $t('Submit') }}</span>
            <svg class="o-icon"><use xlink:href="#check"></use></svg>
          </button>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import BaseInput from 'theme/components/Form/BaseInput'

export default {
  name: 'EditValue',
  props: [
    'scopedValue',
    'editMode',
    'name',
    'mageCallIdentifier',
    'inputValidation', // used to customize a single input - otherwise use slot
    'classInput' // used to customize a single input - otherwise use slot
  ],
  $_veeValidate: {
    validator: 'new',
    value () {
      return this.inEditingValue
    },
    name () {
      return this.name
    }
  },
  data () {
    return {
      switchToEditMode: false,
      inEditingValue: ''
    }
  },
  methods: {
    editCurrent () {
      this.switchToEditMode = true
    },
    submitValue () {
      return this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.$emit('submitValue', { dataIdentifier: this.mageCallIdentifier, value: this.inEditingValue })
        }
      })
    }
  },
  watch: {
    editMode: function (value) {
      if (!value) {
        this.switchToEditMode = false
      }
    }
  },
  mounted () {
    this.inEditingValue = this.scopedValue || ''
  },
  components: {
    BaseInput
  }
}
</script>
